import React, { useContext, useEffect } from "react";
import { SectionContainer, SectionContainerWrapper } from "../../../library/utilities/SectionContainer";
import styled, { ThemeContext } from "styled-components";
import { breakpointRuleTablet, ColorGrayscale, ZIndex } from "../../../library/utilities/variables";
import { motion } from "framer-motion";
import { ButtonInverted } from "../../../library/symbols/buttons";
const QuestionFeedbackContainer = styled(SectionContainer) `
    z-index: ${ZIndex.modal};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.primaryColor};
`;
const QuestionFeedbackWrapper = styled(SectionContainerWrapper) `
    z-index: 0;
    position: relative;

    display: flex;
    align-items: center;

    color: ${ColorGrayscale.white};
`;
const QuestionFeedbackMessage = styled(motion.div) `
    max-width: 592px;
    margin: 0 auto;
    text-align: center;
`;
const QuestionFeedbackTitle = styled.h2 `
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: -1px;
    text-align: center;

    margin-bottom: 24px;
`;
const QuestionFeedbackBody = styled.p `
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -1px;
    text-align: center;

    margin-bottom: 48px;
`;
const BackgroundImage = styled(motion.div) `
    z-index: -1;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -98px;
    left: -98px;

    background-image: url(${({ theme }) => theme.feedbackBackgroundUrl});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    @media (${breakpointRuleTablet}) {
        top: -58px;
        right: 0;
        left: 0;
    }
`;
export function QuestionFeedback({ text, title, onAccepted, characterPosition }) {
    const currentTheme = useContext(ThemeContext);
    const BackgroundImageTransition = {
        duration: .4
    };
    const BackgroundImageInitial = {
        y: '100%',
        x: '0%',
        scale: .1
    };
    useEffect(() => {
        switch (characterPosition) {
            case "start":
                BackgroundImageInitial.x = '-50%';
                break;
            case "middle":
                BackgroundImageInitial.x = '0%';
                break;
            case "end":
                BackgroundImageInitial.x = '50%';
                break;
        }
    }, [characterPosition]);
    return (React.createElement(QuestionFeedbackContainer, { initial: { opacity: 1, background: ColorGrayscale.transparent }, animate: { opacity: 1, background: currentTheme.primaryColor }, exit: { opacity: 0, background: ColorGrayscale.transparent } },
        React.createElement(QuestionFeedbackWrapper, null,
            React.createElement(QuestionFeedbackMessage, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { delay: BackgroundImageTransition.duration - .1 } },
                React.createElement(QuestionFeedbackTitle, null, title),
                React.createElement(QuestionFeedbackBody, null, text),
                React.createElement(ButtonInverted, { onClick: () => onAccepted() }, "Continuar")),
            React.createElement(BackgroundImage, { initial: BackgroundImageInitial, animate: { y: 0, x: 0, scale: 1 }, exit: BackgroundImageInitial, transition: BackgroundImageTransition }))));
}
